<template>
    <div class="image-box shadow-sm" :class="[extraClass, {selected: selected}]" :style="`background-image: url(${image});`">
      <span class="title text-white px-2">{{ title }}</span>
      <i class="fas fa-check-circle fa-2x" v-if="selected"></i>
    </div>
</template>
<script>
export default {
  name: "image-box",
  props: {
    image: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    id: {
      type: Number,
      default: 0,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    extraClass: {
      type: String,
      default: "",
    }
  },
  methods: {

  }
};
</script>
<style>
</style>
